import React, {useState, useEffect} from 'react'
import './fleetStatusSummary.scss';

export default function FleetStatusSummary({items, action}) {

    const [vehicleCounts, setVehicleCounts] = useState(null)
    const [sortKey, setSortKey] = useState('total')
    const [sortDir, setSortDir] = useState('desc')

    function handleSort(key) {
        if (sortKey === key) {
            setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
        } else {
            setSortKey(key);
            setSortDir(key === 'type' ? 'asc' : 'desc');
        }
    }

    function sortIndicator(key) {
        if (sortKey !== key) return null;
        return <span className='sort-indicator'>{sortDir === 'asc' ? '\u25B2' : '\u25BC'}</span>;
    }

    function getVehicleCounts(vehicles) {
        const vehicleCounts = {};

        vehicles.forEach((vehicle) => {
            const { vehicle_type_name, vehicle_status_name } = vehicle;

            // Initialize vehicle type object if it doesn't exist
            if (!vehicleCounts[vehicle_type_name]) {
            vehicleCounts[vehicle_type_name] = { total: 0 };
            }

            // Increment total count for vehicle type
            vehicleCounts[vehicle_type_name].total++;

            // Initialize vehicle status count if it doesn't exist
            if (!vehicleCounts[vehicle_type_name][vehicle_status_name]) {
            vehicleCounts[vehicle_type_name][vehicle_status_name] = 0;
            }

            // Increment count for vehicle status
            vehicleCounts[vehicle_type_name][vehicle_status_name]++;
        });

        return vehicleCounts;
    }
  

    useEffect(() => {
    
        async function fetchData() {
          await setVehicleCounts(getVehicleCounts(items));
        }
        fetchData();
        
      }, [items]);


      if (vehicleCounts) {
        // Status columns ordered by fleet-wide count, vehicle type rows ordered by total
        const statusTotals = {};
        Object.values(vehicleCounts).forEach((counts) => {
          Object.keys(counts).forEach((status) => {
            if (status !== 'total') {
              statusTotals[status] = (statusTotals[status] || 0) + counts[status];
            }
          });
        });
        const statusColumns = Object.keys(statusTotals).sort((a, b) => statusTotals[b] - statusTotals[a]);

        const direction = sortDir === 'asc' ? 1 : -1;
        const typeRows = Object.keys(vehicleCounts).sort((a, b) => {
            if (sortKey === 'type') return a.localeCompare(b) * direction;
            const aValue = sortKey === 'total' ? vehicleCounts[a].total : (vehicleCounts[a][sortKey] || 0);
            const bValue = sortKey === 'total' ? vehicleCounts[b].total : (vehicleCounts[b][sortKey] || 0);
            return (aValue - bValue) * direction;
        });

        return <div className='box box--wide'>
        <div className='summary'>
          <div className='card-header'>
            <h2>Fleet Status</h2>
            {action && <div className='header-action'>{action}</div>}
          </div>
          <div className='status-table-wrap'>
            <table className='status-table'>
              <thead>
                <tr>
                  <th className='type-col' onClick={() => handleSort('type')}>Asset Type{sortIndicator('type')}</th>
                  <th onClick={() => handleSort('total')}>Total{sortIndicator('total')}</th>
                  {statusColumns.map((status) => <th key={status} onClick={() => handleSort(status)}>{status}{sortIndicator(status)}</th>)}
                </tr>
              </thead>
              <tbody>
                {typeRows.map((typeName) => {
                  const counts = vehicleCounts[typeName];
                  return <tr key={typeName}>
                    <th className='type-col'>{typeName}</th>
                    <td className='total-col'>{counts.total}</td>
                    {statusColumns.map((status) => (
                      <td key={status} className={counts[status] ? '' : 'empty-cell'}>
                        {counts[status] || '\u2013'}
                      </td>
                    ))}
                  </tr>
                })}
                <tr className='totals-row'>
                  <th className='type-col'>All Types</th>
                  <td className='total-col'>{typeRows.reduce((sum, typeName) => sum + vehicleCounts[typeName].total, 0)}</td>
                  {statusColumns.map((status) => <td key={status}>{statusTotals[status]}</td>)}
                </tr>
              </tbody>
            </table>
          </div>
          </div>
          </div>;
      }
    
   
}



 